/* OLEEYA desktop search: focus opens categories, typing shows Shopify search matches. */
(function(){
 function init(){
  const shell=document.querySelector('.oleeya-desktop-search-shell');
  if(!shell||shell.dataset.initialized)return;
  shell.dataset.initialized='true';
  const form=shell.querySelector('form');
  const input=shell.querySelector('#oleeya-desktop-search-input');
  const button=form?.querySelector('button[type=submit]');
  const popup=shell.querySelector('.oleeya-desktop-search-panel');
  const defaults=popup?.querySelector('.oleeya-desktop-search-default');
  const live=popup?.querySelector('.oleeya-desktop-search-live');
  if(!form||!input||!popup||!defaults||!live)return;
  let timer=null,request=null,serial=0;
  const mk=(tag,cls,txt)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(txt!==undefined)e.textContent=txt;return e};
  const searchUrl=term=>{const u=new URL(form.action,location.origin);u.searchParams.set('q',term);u.searchParams.set('type','product');return u.href};
  function show(){
   popup.hidden=false;
   input.setAttribute('aria-expanded','true');
  }
  function close(){
   popup.hidden=true;
   input.setAttribute('aria-expanded','false');
  }
  function original(){
   defaults.hidden=false;live.hidden=true;live.replaceChildren();show();
  }
  const heading=t=>live.appendChild(mk('div','oleeya-predictive-heading',t));
  function row(label,url){
   const a=mk('a','oleeya-predictive-row',label);a.href=url;return a;
  }
  function showLive(terms,products,term){
   if(input.value.trim()!==term)return;
   defaults.hidden=true;live.hidden=false;live.replaceChildren();
   if(terms.length){
    heading('Suggestions');
    terms.slice(0,6).forEach(t=>live.appendChild(row(t,searchUrl(t))));
   }
   if(products.length){
    heading('Products');
    products.slice(0,6).forEach(p=>{
     const a=row('',p.url||searchUrl(p.title||term));
     if(p.image){const img=mk('img','oleeya-predictive-product-img');img.src=p.image;img.loading='lazy';img.alt='';a.appendChild(img)}
     const t=mk('span','oleeya-predictive-product-text');
     t.appendChild(mk('span','oleeya-predictive-product-title',p.title||'Product'));
     if(p.price)t.appendChild(mk('span','oleeya-predictive-product-price',p.price));
     a.appendChild(t);live.appendChild(a);
    });
   }
   if(!terms.length&&!products.length)live.appendChild(mk('div','oleeya-predictive-message','No matching products. Try another keyword.'));
   const all=mk('a','oleeya-predictive-search-all','View all results for “'+term+'”');
   all.href=searchUrl(term);live.appendChild(all);show();
  }
  async function fetchMatches(){
   const term=input.value.trim(),current=++serial;
   if(request)request.abort();
   if(!term){original();return}
   request=new AbortController();
   const url=new URL(form.action,location.origin);
   url.searchParams.set('q',term);
   url.searchParams.set('type','product');
   url.searchParams.set('section_id','oleeya-mobile-search-results');
   try{
    const response=await fetch(url.href,{credentials:'same-origin',signal:request.signal,headers:{Accept:'text/html'}});
    if(!response.ok)throw Error('HTTP '+response.status);
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const root=doc.querySelector('[data-oleeya-search-source]');
    if(!root)throw Error('Missing search results');
    const products=Array.from(root.querySelectorAll('[data-oleeya-search-product]')).map(n=>({
     title:n.getAttribute('data-title')||'',
     url:n.getAttribute('data-url')||'',
     price:n.getAttribute('data-price')||'',
     image:n.getAttribute('data-image')||'',
     type:n.getAttribute('data-type')||''
    }));
    if(serial!==current)return;
    const types=[...new Set(products.map(p=>p.type).filter(Boolean))];
    showLive(types,products,term);
   }catch(err){
    if(err.name==='AbortError'||current!==serial)return;
    defaults.hidden=true;live.hidden=false;live.replaceChildren();
    live.appendChild(mk('div','oleeya-predictive-message','Search suggestions unavailable. Press Enter to see all results.'));
    const all=mk('a','oleeya-predictive-search-all','Search for “'+term+'”');all.href=searchUrl(term);live.appendChild(all);show();
   }
  }
  input.addEventListener('focus',()=>{if(input.value.trim())fetchMatches();else original()});
  input.addEventListener('click',()=>{if(!input.value.trim())original()});
  input.addEventListener('input',()=>{
   clearTimeout(timer);
   if(!input.value.trim()){serial++;if(request)request.abort();original();return}
   timer=setTimeout(fetchMatches,220);
  });
  button?.addEventListener('click',event=>{
   if(!input.value.trim()){event.preventDefault();input.focus();original()}
  });
  input.addEventListener('keydown',event=>{if(event.key==='Escape'){close();input.blur()}});
  document.addEventListener('pointerdown',event=>{if(!shell.contains(event.target))close()});
  window.addEventListener('scroll',()=>{if(!popup.hidden&&Math.abs(shell.getBoundingClientRect().top)>innerHeight)close()},{passive:true});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
 else init();
 document.addEventListener('shopify:section:load',init);
})();